import {AUTHENTICATION_URL, BASE_URL} from "../src/constants/constants";

export const getProjectDetailService = (id) => {
    return fetch(`${BASE_URL}/api/projects/${id}?populate=%2A`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization':AUTHENTICATION_URL,
        },
    }).then(response => {
        return response;
    }).then(response=> {
        return response.json()
    }).catch(error=>{
        console.log(error)
    });
}
